import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ModalProvider } from './context/ModalContext';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import ChatApp from './components/ChatApp';
import LoginPage from './pages/LoginPage'; // Добавляем страницу входа
import RegisterPage from './pages/RegisterPage'; // Добавляем страницу регистрации
import ConfirmCodePage from './pages/ConfirmCodePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';


const App: React.FC = () => {
  return (
    <ModalProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/chat/" element={<ChatApp />} />
          <Route path="/chat/:uuid" element={<ChatApp />} />
          <Route path="/login" element={<LoginPage />} /> {/* Новый маршрут */}
          <Route path="/register" element={<RegisterPage />} /> {/* Новый маршрут */}
          <Route path="/confirm-code" element={<ConfirmCodePage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Routes>
      </Router>
    </ModalProvider>
  );
};

export default App;